@if(isBrowser){
    <footer id="footer">
        <div class="container">
            @if(settings_data){
                <div class="footer-warapper">
                    <div class="col-left">
                        <div id="copyright" class="col-left" [innerHTML]="settings_data[2]?.value"></div>
                    </div>
                    <div class="col-right ml-auto">
                        <ul id="credit">
                            <li>
                                <a href="javascript:void(0);" routerLink="/terms-conditions">terms of use</a>
                            </li>
                            <li>
                                <a href="javascript:void(0);" routerLink="/faqs">FAQs</a>
                            </li>
                            <li>
                                <a href="javascript:void(0);" routerLink="/employment">employment</a>
                            </li>
                            <li>
                                @if(!login){
                                    <a href="javascript:void(0);" routerLink="/login">login</a>
                                }
                            </li>
                            <li>
                                <a href="javascript:void(0);" routerLink="/privacy-policy">privacy policy</a>
                            </li>
                            <li>
                                <span class="copyright-text">© {{currentYear}}, Spur Experiences</span>
                            </li>
                        </ul>
                        

                        <div class="footer__social">
                            <ul class="header-social-links">
                                <li>
                                    <a class="facbook-flip" rel=”nofollow” href="{{ facebookSocialLink }}"
                                        target="_blank">Facebook</a>
                                </li>
                                <li>
                                    <a class="linkedin-flip" rel=”nofollow” href="{{ linkedinSocialLink }}"
                                        target="_blank">Linkedin</a>
                                </li>
                                <li>
                                    <a class="pinterest-flip" rel=”nofollow” href="{{ pinterestSocialLink }}"
                                        target="_blank">Pinterest</a>
                                </li>
                                <li>
                                    <a class="instagram-flip" rel=”nofollow” href="{{ instagramSocialLink }}"
                                        target="_blank">Instagram</a>
                                </li>
                                <li>
                                    <a class="tiktok-flip" rel=”nofollow” href="{{ tiktokSocialLink }}"
                                        target="_blank">Tiktok</a>
                                </li>
                                  
                            </ul>
                            <ul class="appDownload__icon">
                                <li class="nav-item cart-info d-none d-md-block">
                                    <a class="nav-link app-icons-section p-0" href="https://play.google.com/store/apps/details?id=com.vebolife&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                                        <img class="app-images" src="../../../assets/images/Play_Store_icon.png" width="" alt="">
                                    </a>
                                </li>
                                <li class="nav-item cart-info d-none d-md-block">
                                    <a class="nav-link app-icons-section p-0" href="https://apps.apple.com/in/app/spur-experiences/id1123434344" target="_blank" rel="noopener noreferrer">
                                        <img class="app-images" src="../../../assets/images/Apple_app_icon.png" width="" alt="">
                                    </a>
                                </li> 
                            </ul>
                            </div>
                      
                        
                    </div>
                </div>
            }
        </div>
    </footer>
}

<!-- <a id="msgIocnFixed">
    <i class="far fa-envelope"></i>
</a> -->